import { createCustomAction } from 'typesafe-actions';

import {
  standardEmptyACC,
  standardFailedACC,
  standardFlowACC,
} from '../../utils/sagas';

const REQUESTED = '$OPEN_STAGED_PURCHASE/REQUESTED';
const BLOCKED = '$OPEN_STAGED_PURCHASE/BLOCKED';
const APPROVED = '$OPEN_STAGED_PURCHASE/APPROVED';
const SUCCEEDED = '$OPEN_STAGED_PURCHASE/SUCCEEDED';
const FAILED = '$OPEN_STAGED_PURCHASE/FAILED';

const request = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      purchaseId: string;
    }>(type);
};

const succeed = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      purchase: _Purchase;
    }>(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, succeed),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
